<template>
  <div class="p-4">
    <h2>{{ filterQuery | Capitalize }} Restaurants</h2>
    <div v-if="show" class="row mt-4">
      <div v-for="rs in orderedResturants" :key="rs.ID" class="col-md-3 mb-4">
        <div class="rs-item">
          <a @click="navigateToStore(rs)">
            <div
              :style="{ 'background-image': 'url(' + rs.ProfileImage + ')' }"
              class="w-100 rs-img-item"
            >
              <span v-if="pos" class="fs-90">
                <i class="material-icons">near_me</i>
                {{ distance(rs.Location.Latitude, rs.Location.Longitude) }}km
                away
              </span>
            </div>
            <span class="d-block mt-2 font-weight-bold">{{ rs.Name }}</span>
            <div>{{ rs.StoreTitle }}</div>
            <div v-if="getOperatingHours(rs)" class="fs-80 color-gray">
              Open
              <span>{{ getOperatingHours(rs).openTime }}</span> to
              <span>{{ getOperatingHours(rs).closeTime }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div v-else>
      <message message="No store available in database" v-show="!busy" />
    </div>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/master/Resturant/ResturantsFilter.js";

import Message from "../../shared/Message";
export default {
  components: {
    Message
  },
  filters: {
    ...shared.filters
  },
  props: {
    filterQuery: {
      type: String,
      default: "all"
    }
  },
  data() {
    return {
      populars: [],
      pos: null,
      busy: false
    };
  },
  computed: {
    ...shared.computed
  },
  watch: {
    filterQuery(newValue) {
      this.populars = [];
      if (newValue === "all") {
        this.getStores();
      } else {
        this.getnearStores();
      }
    }
  },
  created() {
    this.checkLocation();
    this.getStores();
  },
  methods: {
    ...shared.methods
  }
};
</script>
